import * as d3 from 'd3';
import React from 'react';
import Widget from '../../../../core/models/widget';
import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import Legends from "../timeseries-chart/legend/legends.jsx";
import moment from "moment";
import styles from './styles.scss';
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator.js";

const techan = require('../../../../vendors/techanjs/techanjs.js');

import {TechnicalAnalysisChartController} from './controller';

// import styles from './styles.scss';


export class TechnicalAnalysisWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.controller = new TechnicalAnalysisChartController(this.props.widget, this.updateCallback, this.props.togglePreloader);
    this.indicatorPreRoll = 33;
    this.ohlcClipId = UniqueIdGenerator.id();
    this.indicatorClipId = UniqueIdGenerator.id();
    console.log("tech widget id: " + this.props.widget.id);
  }

  updateCallback(data) {
    const parseDate = d3.timeParse("%d-%b-%y");
    let mainDataIndex = data.map(d => d[0]).findIndex(d => d.legendId === 'TAC');
    if (mainDataIndex === -1) {
      mainDataIndex = 0;
    }
    this.layerdData = data.map(layerData => {
      return layerData.map(d => {
        return {
          date: parseDate(moment(d.time * 1000).format("D-MMM-YY")),
          open: +d.y,
          high: +d.y,
          low: +d.y,
          close: +d.y,
          volume: 0,
          legendId: d.legendId
        };
      });
    });
    this.data = this.layerdData[mainDataIndex];
    this.renderChart();
  }


  getOHLCHeight() {
    let height = this.$widget.height();
    let margins = this.getMargins();
    height = height - margins.bottom - margins.top;
    if (this.isMACDActive()) {
      height -= 75;
    }

    if (this.isRSIActive()) {
      height -= 75;
    }

    return height;
  }

  isMACDActive() {
    const macd = this.getLegends().find(l => l.id === "MACD");
    return macd ? macd.parameters.isActive && this.data.length > this.indicatorPreRoll : false;
  }

  isRSIActive() {
    const rsi = this.getLegends().find(l => l.id === "RSI");
    return rsi ? rsi.parameters.isActive && this.data.length > this.indicatorPreRoll : false;
  }

  isSMAActive() {
    const sma = this.getLegends().find(l => l.id === "SMA");
    return sma ? sma.parameters.isActive && this.data.length > this.indicatorPreRoll : false;
  }

  getLegendById(id) {
    return this.getLegends().find(l => l.id === id);
  }

  componentDidMount() {
    this.listenEvents();
    this.$widget = $("#" + this.props.widget.id);
    WidgetService.addComponentToWidget(this.props.widget.id, this.controller);
    // this.renderChart();
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  renderChart() {
    const data = this.data;
    const layeredData = this.layerdData;
    d3.select(`#ta-${this.props.widget.id}`).html("");
    const _this = this;
    var dim = {
      width: this.$widget.width(), height: this.$widget.height(),
      margin: this.getMargins(),
      ohlc: {height: this.getOHLCHeight()},
      indicator: {height: 65, padding: 5}
    };
    dim.plot = {
      width: dim.width - dim.margin.left - dim.margin.right,
      height: dim.height - dim.margin.top - dim.margin.bottom
    };
    dim.indicator.top = dim.ohlc.height + dim.indicator.padding;
    dim.indicator.bottom = dim.indicator.top + dim.indicator.height + dim.indicator.padding;

    // rsi is rendered at the bottom of the indicator
    // if MACD is disabled it should be rendered at the top of the indicator
    if (!this.isMACDActive()) {
      dim.indicator.bottom = dim.indicator.top;
    }

    var indicatorTop = d3.scaleLinear()
      .range([dim.indicator.top, dim.indicator.bottom]);

    var parseDate = d3.timeParse("%d-%b-%y");

    var zoom = d3.zoom()
      .on("zoom", zoomed);

    var x = techan.scale.financetime()
      .range([0, dim.plot.width]);

    var y = d3.scaleLinear()
      .range([dim.ohlc.height, 0]);


    var yPercent = y.copy();   // Same as y at this stage, will get a different domain later

    var yInit, yPercentInit, zoomableInit;

    var yVolume = d3.scaleLinear()
      .range([y(0), y(0.2)]);

    var candlestick = techan.plot.candlestick()
      .xScale(x)
      .yScale(y);

    var tradearrow = techan.plot.tradearrow()
      .xScale(x)
      .yScale(y)
      .y(function (d) {
        // Display the buy and sell arrows a bit above and below the price, so the price is still visible
        if (d.type === 'buy') return y(d.low) + 5;
        if (d.type === 'sell') return y(d.high) - 5;
        else return y(d.price);
      });

    var sma0 = techan.plot.sma()
      .xScale(x)
      .yScale(y);

    var sma1 = techan.plot.sma()
      .xScale(x)
      .yScale(y);

    var ema2 = techan.plot.ema()
      .xScale(x)
      .yScale(y);

    var volume = techan.plot.volume()
      .accessor(candlestick.accessor())   // Set the accessor to a ohlc accessor so we get highlighted bars
      .xScale(x)
      .yScale(yVolume);

    var trendline = techan.plot.trendline()
      .xScale(x)
      .yScale(y);

    var supstance = techan.plot.supstance()
      .xScale(x)
      .yScale(y);

    var xAxis = d3.axisBottom(x);

    var timeAnnotation = techan.plot.axisannotation()
      .axis(xAxis)
      .orient('bottom')
      .format(d3.timeFormat('%Y-%m-%d'))
      .width(65)
      .translate([0, dim.plot.height]);

    var yAxis = d3.axisRight(y);

    var ohlcAnnotation = techan.plot.axisannotation()
      .axis(yAxis)
      .orient('right')
      .format(d3.format(',.2f'))
      .translate([x(1), 0]);

    var closeAnnotation = techan.plot.axisannotation()
      .axis(yAxis)
      .orient('right')
      .accessor(candlestick.accessor())
      .format(d3.format(',.2f'))
      .translate([x(1), 0]);

    var percentAxis = d3.axisLeft(y);
    // .tickFormat(d3.format('+.1%'));

    var percentAnnotation = techan.plot.axisannotation()
      .axis(percentAxis)
      .orient('left')
      .format(d3.format(',.2f'));

    var volumeAxis = d3.axisRight(yVolume)
      .ticks(3)
      .tickFormat(d3.format(",.3s"));

    var volumeAnnotation = techan.plot.axisannotation()
      .axis(volumeAxis)
      .orient("right")
      .width(35);

    var macdScale = d3.scaleLinear()
      .range([indicatorTop(0) + dim.indicator.height, indicatorTop(0)]);

    var rsiScale = macdScale.copy()
      .range([indicatorTop(1) + dim.indicator.height, indicatorTop(1)]);

    var macd = techan.plot.macd()
      .xScale(x)
      .yScale(macdScale);

    var macdAxis = d3.axisRight(macdScale)
      .ticks(3);

    var macdAnnotation = techan.plot.axisannotation()
      .axis(macdAxis)
      .orient("right")
      .format(d3.format(',.2f'))
      .translate([x(1), 0]);

    var macdAxisLeft = d3.axisLeft(macdScale)
      .ticks(3);

    var macdAnnotationLeft = techan.plot.axisannotation()
      .axis(macdAxisLeft)
      .orient("left")
      .format(d3.format(',.2f'));

    var rsi = techan.plot.rsi()
      .xScale(x)
      .yScale(rsiScale);

    var rsiAxis = d3.axisRight(rsiScale)
      .ticks(3);

    var rsiAnnotation = techan.plot.axisannotation()
      .axis(rsiAxis)
      .orient("right")
      .format(d3.format(',.2f'))
      .translate([x(1), 0]);

    var rsiAxisLeft = d3.axisLeft(rsiScale)
      .ticks(3);

    var rsiAnnotationLeft = techan.plot.axisannotation()
      .axis(rsiAxisLeft)
      .orient("left")
      .format(d3.format(',.2f'));

    var ohlcCrosshair = techan.plot.crosshair()
      .xScale(timeAnnotation.axis().scale())
      .yScale(ohlcAnnotation.axis().scale())
      .xAnnotation(timeAnnotation)
      .yAnnotation([ohlcAnnotation, percentAnnotation])
      .verticalWireRange([0, dim.plot.height]);

    var macdCrosshair = techan.plot.crosshair()
      .xScale(timeAnnotation.axis().scale())
      .yScale(macdAnnotation.axis().scale())
      .xAnnotation(timeAnnotation)
      .yAnnotation([macdAnnotation, macdAnnotationLeft])
      .verticalWireRange([0, dim.plot.height]);

    var rsiCrosshair = techan.plot.crosshair()
      .xScale(timeAnnotation.axis().scale())
      .yScale(rsiAnnotation.axis().scale())
      .xAnnotation(timeAnnotation)
      .yAnnotation([rsiAnnotation, rsiAnnotationLeft])
      .verticalWireRange([0, dim.plot.height]);

    var svg = d3.select(`#ta-${this.props.widget.id}`).append("svg")
      .attr("width", dim.width)
      .attr("height", dim.height);

    var defs = svg.append("defs");

    defs.append("clipPath")
      .attr("id", this.ohlcClipId)
      .append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", dim.plot.width)
      .attr("height", dim.ohlc.height);

    defs.selectAll("indicatorClip").data([0, 1])
      .enter()
      .append("clipPath")
      .attr("id", (d, i) => {
        return `${this.indicatorClipId}-${i}`;
      })
      .append("rect")
      .attr("x", 0)
      .attr("y", function (d, i) {
        return indicatorTop(i);
      })
      .attr("width", dim.plot.width)
      .attr("height", dim.indicator.height);

    svg = svg.append("g")
      .attr("transform", "translate(" + dim.margin.left + "," + dim.margin.top + ")");

    // svg.append('text')
    //   .attr("class", "symbol")
    //   .attr("x", 20)
    //   .text("Facebook, Inc. (FB)");

    svg.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + dim.plot.height + ")");

    var ohlcSelection = svg.append("g")
      .attr("class", "ohlc")
      .attr("transform", "translate(0,0)");

    ohlcSelection.append("g")
      .attr("class", "axis")
      .attr("transform", "translate(" + x(1) + ",0)")
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", -12)
      .attr("dy", ".71em");
    //
    // .style("text-anchor", "end")
    // .text("Price ($)");

    ohlcSelection.append("g")
      .attr("class", "close annotation up");

    ohlcSelection.append("g")
      .attr("class", "volume")
      .attr("clip-path", `url(#${this.ohlcClipId})`);

    ohlcSelection.append("g")
      .attr("class", "candlestick")
      .attr("clip-path", `url(#${this.ohlcClipId})`);

    ohlcSelection.append("g")
      .attr("class", "indicator sma ma-0")
      .attr("clip-path",`url(#${this.ohlcClipId})`);

    ohlcSelection.append("g")
      .attr("class", "indicator sma ma-1")
      .attr("clip-path", `url(#${this.ohlcClipId})`);

    ohlcSelection.append("g")
      .attr("class", "indicator ema ma-2")
      .attr("clip-path",`url(#${this.ohlcClipId})`);

    const nonTACLegends = _this.props.widget.legends.filter(l => typeof l.id === 'number');
    nonTACLegends.forEach(l => {
      ohlcSelection.append("g")
        .attr("class", `line layer-${l.id}`)
        .attr("clip-path", `url(#${this.ohlcClipId})`)
        .append("path");
    });

    ohlcSelection.append("g")
      .attr("class", "line layer1")
      .attr("clip-path",`url(#${this.ohlcClipId})`)
      .append("path");


    ohlcSelection.append("g")
      .attr("class", "percent axis");

    ohlcSelection.append("g")
      .attr("class", "volume axis");

    var indicatorSelection = svg.selectAll("svg > g.indicator").data(["macd", "rsi"]).enter()
      .append("g")
      .attr("class", function (d) {
        return d + " indicator";
      });

    indicatorSelection.append("g")
      .attr("class", "axis right")
      .attr("transform", "translate(" + x(1) + ",0)");

    indicatorSelection.append("g")
      .attr("class", "axis left")
      .attr("transform", "translate(" + x(0) + ",0)");

    indicatorSelection.append("g")
      .attr("class", "indicator-plot")
      .attr("clip-path", (d, i) => {
        return `url(#${this.indicatorClipId}-${i})`;
      });

    // Add trendlines and other interactions last to be above zoom pane
    svg.append('g')
      .attr("class", "crosshair ohlc");

    svg.append("g")
      .attr("class", "tradearrow")
      .attr("clip-path", `url(#${this.ohlcClipId})`);


    if (this.isRSIActive()) {
      svg.append('g')
        .attr("class", "crosshair rsi");
    }

    if (this.isMACDActive()) {
      svg.append('g')
        .attr("class", "crosshair macd");
    }

    svg.append("g")
      .attr("class", "trendlines analysis")
      .attr("clip-path", `url(#${this.ohlcClipId})`);
    svg.append("g")
      .attr("class", "supstances analysis")
      .attr("clip-path", `url(#${this.ohlcClipId})`);


    d3.select("button").on("click", reset);

    // var data = this.testData();

    var accessor = candlestick.accessor(),
      indicatorPreRoll = 33;  // Don't show where indicators don't have data

    // data = data.map(function (d) {
    //   return {
    //     date: parseDate(d.Date),
    //     open: +d.Open,
    //     high: +d.High,
    //     low: +d.Low,
    //     close: +d.Close,
    //     volume: +d.Volume
    //   };
    // }).sort(function (a, b) {
    //   return d3.ascending(accessor.d(a), accessor.d(b));
    // });

    if (_this.getLegendById('TAC')) {
      y.domain(techan.scale.plot.ohlc(data).domain());
      yPercent.domain(techan.scale.plot.percent(y, accessor(data)).domain());
      yVolume.domain(techan.scale.plot.volume(data).domain());
    } else {
      let concatedData = [];
      _this.layerdData.forEach(l => {
        const legendId = l[0].legendId;
        const legend = _this.props.widget.legends.find(l => l.id === legendId);
        if (legend.parameters.isActive) {
          concatedData = concatedData.concat(l);
        }
      });
      y.domain(techan.scale.plot.ohlc(concatedData).domain());
      yPercent.domain(techan.scale.plot.percent(y, accessor(concatedData)).domain());
      yVolume.domain(techan.scale.plot.volume(concatedData).domain());
    }

    x.domain(techan.scale.plot.time(data).domain());


    // var trendlineData = [
    //   {start: {date: new Date(2014, 2, 11), value: 72.50}, end: {date: new Date(2014, 5, 9), value: 63.34}},
    //   {start: {date: new Date(2013, 10, 21), value: 43}, end: {date: new Date(2014, 2, 17), value: 70.50}}
    // ];
    //
    // var supstanceData = [
    //   {start: new Date(2014, 2, 11), end: new Date(2014, 5, 9), value: 63.64},
    //   {start: new Date(2013, 10, 21), end: new Date(2014, 2, 17), value: 55.50}
    // ];
    //
    // var trades = [
    //   {date: data[67].date, type: "buy", price: data[67].low, low: data[67].low, high: data[67].high},
    //   {date: data[100].date, type: "sell", price: data[100].high, low: data[100].low, high: data[100].high},
    //   {date: data[130].date, type: "buy", price: data[130].low, low: data[130].low, high: data[130].high},
    //   {date: data[170].date, type: "sell", price: data[170].low, low: data[170].low, high: data[170].high}
    // ];

    var macdData = techan.indicator.macd()(data);
    macdScale.domain(techan.scale.plot.macd(macdData).domain());
    var rsiData = techan.indicator.rsi()(data);
    rsiScale.domain(techan.scale.plot.rsi(rsiData).domain());

    // svg.select("g.candlestick").datum(data).call(candlestick);
    if (_this.getLegendById('TAC')) {
      svg.select("g.close.annotation").datum([data[data.length - 1]]).call(closeAnnotation);
    }

    svg.select("g.volume").datum(data).call(volume);


    svg.select("g.crosshair.ohlc").call(ohlcCrosshair).call(zoom);

    if (this.isSMAActive()) {
      const legend = this.getLegendById('SMA');
      const period = legend.parameters.period ? parseInt(legend.parameters.period) : 10;
      svg.select("g.sma.ma-0").datum(techan.indicator.sma().period(period)(data)).call(sma0);
      // svg.select("g.sma.ma-1").datum(techan.indicator.sma().period(20)(data)).call(sma1);
      // svg.select("g.ema.ma-2").datum(techan.indicator.ema().period(50)(data)).call(ema2);
    }

    if (this.isRSIActive()) {
      svg.select("g.rsi .indicator-plot").datum(rsiData).call(rsi);
      svg.select("g.crosshair.rsi").call(rsiCrosshair).call(zoom);
    }

    if (this.isMACDActive()) {
      svg.select("g.macd .indicator-plot").datum(macdData).call(macd);
      svg.select("g.crosshair.macd").call(macdCrosshair).call(zoom);

    }

    // svg.select("g.trendlines").datum(trendlineData).call(trendline).call(trendline.drag);
    // svg.select("g.supstances").datum(supstanceData).call(supstance).call(supstance.drag);
    //
    // svg.select("g.tradearrow").datum(trades).call(tradearrow);

    // Stash for zooming
    zoomableInit = x.zoomable().domain([0, data.length]).copy(); // Zoom in a little to hide indicator preroll
    yInit = y.copy();
    yPercentInit = yPercent.copy();

    draw();

    function reset() {
      zoom.scale(1);
      zoom.translate([0, 0]);
      draw();
    }

    function zoomed() {
      x.zoomable().domain(d3.event.transform.rescaleX(zoomableInit).domain());
      y.domain(d3.event.transform.rescaleY(yInit).domain());
      yPercent.domain(d3.event.transform.rescaleY(yPercentInit).domain());

      draw();
    }


    function draw() {
      svg.select("g.x.axis").call(xAxis);
      svg.select("g.ohlc .axis").call(yAxis);
      // svg.select("g.volume.axis").call(volumeAxis);
      svg.select("g.percent.axis").call(percentAxis);


      // We know the data does not change, a simple refresh that does not perform data joins will suffice.
      // svg.select("g.candlestick").call(candlestick.refresh);
      svg.select("g.close.annotation").call(closeAnnotation.refresh);
      svg.select("g.volume").call(volume.refresh);

      svg.select("g.crosshair.ohlc").call(ohlcCrosshair.refresh);
      // svg.select("g.trendlines").call(trendline.refresh);
      // svg.select("g.supstances").call(supstance.refresh);
      // svg.select("g.tradearrow").call(tradearrow.refresh);

      if (_this.isSMAActive()) {
        svg.select("g .sma.ma-0").call(sma0.refresh);

        const SMALegend = _this.getLegendById("SMA");
        svg.select("g.sma").select("path.line")
          .style("stroke", SMALegend.parameters.legendColor)
          .style("opacity", SMALegend.parameters.chartTypeParameters.strokeOpacity);

        // svg.select("g .sma.ma-1").call(sma1.refresh);
        // svg.select("g .ema.ma-2").call(ema2.refresh);
      }

      if (_this.isRSIActive()) {
        svg.select("g.rsi .axis.right").call(rsiAxis);
        svg.select("g.rsi .axis.left").call(rsiAxisLeft);
        svg.select("g.crosshair.rsi").call(rsiCrosshair.refresh);
        svg.select("g.rsi .indicator-plot").call(rsi.refresh);

        const RSILegend = _this.getLegendById("RSI");
        svg.select("g.rsi").select("path.rsi")
          .style("stroke", RSILegend.parameters.legendColor)
          .style("opacity", RSILegend.parameters.chartTypeParameters.strokeOpacity);
      }

      if (_this.isMACDActive()) {
        svg.select("g.macd .axis.right").call(macdAxis);
        svg.select("g.macd .axis.left").call(macdAxisLeft);
        svg.select("g.macd .indicator-plot").call(macd.refresh);
        svg.select("g.crosshair.macd").call(macdCrosshair.refresh);

        const MACDLegend = _this.getLegendById("MACD");
        svg.select("g.macd").select("path.macd")
          .style("stroke", MACDLegend.parameters.legendColor)
          .style("opacity", MACDLegend.parameters.chartTypeParameters.strokeOpacity);
        svg.select("g.macd").select("path.signal")
          .style("stroke", MACDLegend.parameters.legendColor)
          .style("opacity", MACDLegend.parameters.chartTypeParameters.strokeOpacity)
          .attr("stroke-dasharray", "5, 5");
      }

      const line = d3.line()
        .curve(d3.curveCardinal)
        .x(d => x(d.date))
        .y(d => y(d.close));

      const dataLegend = _this.getLegendById('TAC');
      if (dataLegend && dataLegend.parameters.isActive) {
        svg.select("g.layer1").select("path")
          .datum(data)
          .attr("fill", "none")
          .attr("stroke", dataLegend.parameters.legendColor)
          .attr("stroke-linejoin", "round")
          .attr("stroke-linecap", "round")
          .attr("stroke-width", 1.5)
          .attr("d", line);
      }

      const nonTACLegends = _this.props.widget.legends.filter(l => typeof l.id === 'number');
      nonTACLegends.forEach(l => {
        if (l.parameters.isActive) {
          let dataIndex = _this.layerdData.map(d => d[0]).findIndex(d => d.legendId === l.id);
          svg.select(`g.layer-${l.id}`).select("path")
            .datum(_this.layerdData[dataIndex])
            .attr("fill", "none")
            .attr("stroke", l.parameters.legendColor)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .attr("stroke-width", 1.5)
            .attr("d", line);
        }
      });
    }
  }

  listenEvents() {
    this.subscribe(InternalEvent.Dashboard.CHART_LEGEND_CLICKED, this.handleChartLegendClicked);
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, this.handleWidgetResize);
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, this.handleWidgetResize);
    this.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, ({widgetId}) => {
      if (this.props.widget.id === widgetId) {
        this.renderChart();
      }
    });
  }

  handleChartLegendClicked({widgetId, legends}) {
    if (this.props.widget.id === widgetId) {
      legends.forEach(l => {
        this.props.widget.legends.forEach(legend => {
          if (l.id === legend.id) {
            legend.parameters["isActive"] = !legend.parameters["isActive"];
          }
        });
      });
      WidgetService.updateWidgetLegends(this.props.widget.id, this.props.widget.legends);

      this.renderChart();
      this.publish(InternalEvent.Dashboard.UPDATE_DASHBOARD_STATE);
      this.forceUpdate();
    }
  }

  handleWidgetResize(payload) {
    const widgetId = $(payload.widget).find("div[data-widget-id]").attr("data-widget-id");
    if (this.props.widget.id === widgetId) {
      this.renderChart();
    }
  }

  getMargins() {
    const titleHeight = this.$widget.find(".widget-header").outerHeight(true) || 0;
    const legendHeight = this.$widget.find("div[name=legendContainer]").outerHeight(true) || 0;
    return {top: titleHeight || 0, right: 50, bottom: legendHeight + 30, left: 50};
  }

  getLegends() {
    const widget = WidgetService.getWidget(this.props.widget.id);
    return widget ? widget.legends : [];
  }

  render() {
    let legend = <Legends widgetId={this.props.widget.id}
                          legends={this.props.widget.legends}
                          metaData={this.props.widget.metaData}
                          onLegendChange={this.legendAltered}/>;
    if (this.props.hideLegends) {
      legend = null;
    }
    return (
      <div>
        <div className={styles.container} ref="container" id={`ta-${this.props.widget.id}`}/>
        {legend}
      </div>

    );
  }
}

TechnicalAnalysisWidget.propTypes = {
  widget: React.PropTypes.instanceOf(Widget).isRequired
};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/technical-analysis-chart/technicalAnalysisWidget.jsx